import * as t from './../../Test/TestFramework';
import { TestCase } from '@signageos/actions/dist/Device/Test/deviceTestActions';
import { IWeinreContainer, startWeinreDebug } from '../Device/Debug/deviceDebugHelper';

export default async (global: IWeinreContainer) => {
	return t.describe(TestCase.WEINRE, function* () {
		yield t.it('should open connection to weinre server', async () => {
			startWeinreDebug(global);
		});
	});
};
